<template>
  <page-wrapper :title="title">
    <div class="row mx-0 mt-3">
      <div class="col-12">
        <div class="text-right">
          <span class="mr-3">Report คัดกรองจากวันที่</span>
          <el-date-picker
            class="date-picker"
            :value="dateTimeReport"
            :picker-options="datePickerOptions.notAfterToday"
            @input="handleChangeDate($event)"
            type="daterange"
            range-separator="ถึง"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <div class="row mx-0 mt-3">
      <div class="col-12">
        <div class="text-right">
          <button
            class="sc-btn sc-btn-outline"
            @click="handleClickDownloadReport(reportType.CONTACT)"
          >ดาวน์โหลดข้อมูลลูกค้า</button>
          <button
            class="sc-btn sc-btn-outline"
            @click="handleClickDownloadReport(reportType.DATA)"
          >ดาวน์โหลดข้อมูลโครงการ</button>
        </div>
      </div>
    </div>
    <div class="justify-content-around project-list">
      <resident-by-project-list-card
        v-model="lowRiseProjects"
        v-if="lowRiseProjects"
        :projectTypeName="lowRiseProjectTypeName"
      ></resident-by-project-list-card>
      <resident-by-project-list-card
        v-model="highRiseProjects"
        v-if="highRiseProjects"
        :projectTypeName="highRiseProjectTypeName"
      ></resident-by-project-list-card>
       <resident-by-project-list-card
        v-model="buildingProjects"
        v-if="buildingProjects"
        :projectTypeName="buildingProjectTypeName"
      ></resident-by-project-list-card>
      <resident-by-project-list-card
          v-model="noneSCLowRiseProjects"
          v-if="noneSCLowRiseProjects"
          :projectTypeName="noneSCLowRiseProjectTypeName"
        ></resident-by-project-list-card>
        <resident-by-project-list-card
          v-model="noneSCHighRiseProjects"
          v-if="noneSCHighRiseProjects"
          :projectTypeName="noneSCHighRiseProjectTypeName"
        ></resident-by-project-list-card>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ResidentByProjectListCard from "../components/ResidentByProjectListCard";
import { toCamelCaseObject } from "@/lib/util";
import { residentReportType } from "@/lib/mapper";
import { getDownloadedReport } from "@/god";
import { DatePicker } from "element-ui";
import { DateTime } from "luxon";
import { isNil } from "ramda";

export default {
  components: {
    PageWrapper,
    ResidentByProjectListCard,
    "el-date-picker": DatePicker
  },
  data() {
    const title = "ข้อมูลผู้ใช้ - โครงการทั้งหมด";
    const highRiseProjects = null;
    const lowRiseProjects = null;
    const buildingProjects = null;
    const noneSCLowRiseProjects = null
    const noneSCHighRiseProjects = null;
    const reportType = residentReportType;
    const selectedDateTimeReport = null;
    const datePickerOptions = {
      notAfterToday: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    }

    return {
      title,
      highRiseProjects,
      lowRiseProjects,
      buildingProjects,
      noneSCLowRiseProjects,
      noneSCHighRiseProjects,
      reportType,
      selectedDateTimeReport,
      datePickerOptions,
      highRiseProjectTypeName: "โครงการแนวสูง",
      lowRiseProjectTypeName: "โครงการแนวราบ",
      buildingProjectTypeName: "อาคาร",
      noneSCLowRiseProjectTypeName: "โครงการแนวราบ Non SC",
      noneSCHighRiseProjectTypeName: "โครงการแนวสูง Non SC"
    };
  },
  created() {
    this.setup();
  },
  computed: {
    dateTimeReport() {
      if (!this.selectedDateTimeReport) {
        return null;
      }

      const { from, to } = this.selectedDateTimeReport;

      return [from.setZone("local").toJSDate(), to.setZone("local").toJSDate()];
    }
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const { high_rise, low_rise, building, none_sc_low_rise, none_sc_high_rise } = await this.fetchList();

      const highRiseProjects = toCamelCaseObject(high_rise.projects).map(item => {
        const route = { name: "ResidentByProjectDetailPage", params: { id: item.id } };

        return { ...item, route };
      });
      const lowRiseProjects = toCamelCaseObject(low_rise.projects).map(item => {
        const route = { name: "ResidentByProjectDetailPage", params: { id: item.id } };

        return { ...item, route };
      });
      const buildingProjects = toCamelCaseObject(building.projects).map(item => {
        const route = { name: "ResidentByProjectDetailPage", params: { id: item.id } };

        return { ...item, route };
      });
      const noneSCLowRiseProjects = toCamelCaseObject(none_sc_low_rise.projects).map(item => {
        const route = { name: "ResidentByProjectDetailPage", params: { id: item.id } };

        return { ...item, route };
      });
      const noneSCHighRiseProjects = toCamelCaseObject(none_sc_high_rise.projects).map(item => {
        const route = { name: "ResidentByProjectDetailPage", params: { id: item.id } };

        return { ...item, route };
      });

      if (high_rise.total_stat.unit_count > 0) {
        this.highRiseProjects = { projects: highRiseProjects, totalStat: toCamelCaseObject(high_rise.total_stat) };
      }

      if (low_rise.total_stat.unit_count > 0) {
        this.lowRiseProjects = { projects: lowRiseProjects, totalStat: toCamelCaseObject(low_rise.total_stat) };
      }

      if (building.total_stat.unit_count > 0) {
        this.buildingProjects = { projects: buildingProjects, totalStat: toCamelCaseObject(building.total_stat) };
      }

      if (none_sc_low_rise.total_stat.unit_count > 0) {
        this.noneSCLowRiseProjects = { projects: noneSCLowRiseProjects, totalStat: toCamelCaseObject(none_sc_low_rise.total_stat) };
      }

      if (none_sc_high_rise.total_stat.unit_count > 0) {
        this.noneSCHighRiseProjects = { projects: noneSCHighRiseProjects, totalStat: toCamelCaseObject(none_sc_high_rise.total_stat) };
      }
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.residents.list();

      return response.data.result;
    },
    async handleClickDownloadReport(type) {
      const dateTime = !isNil(this.selectedDateTimeReport)
        ? {
            start_at: this.selectedDateTimeReport.from.toISO(),
            end_at: this.selectedDateTimeReport.to.toISO()
          }
        : {};

      try {
        const response = await baanRueJaiClient.admin.residents.getReport(
          type,
          dateTime
        );
        const file = response.data;
        const fileName = !isNil(this.selectedDateTimeReport)
          ? `resident-${type}-stat-report-${dateTime.start_at}-${dateTime.end_at}.xlsx`
          : `resident-${type}-stat-report.xlsx`;

        getDownloadedReport(file, fileName);
      } catch(error) {
        // TODO: use alert message from response message backend
        alert("ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด");
        console.error(error);
      }
    },
    handleChangeDate(value) {
      if (!value) {
        this.selectedDateTimeReport = null;

        return;
      }

      const [fromJSDate, toJSDate] = value;
      const from = DateTime.fromJSDate(fromJSDate).startOf("day").toUTC();
      const to = DateTime.fromJSDate(toJSDate).endOf("day").toUTC();

      this.selectedDateTimeReport = { from, to };
    },
  }
}
</script>
<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.project-list {
  height: calc(100% - 50px);
}

.wrapper {
  padding: ($space / 2) $space;
}

.header {
  padding: 30px;
  border-bottom: $border;

  background: #f9f9f9;
}

.sc-btn {
  display: inline-block;
  width: auto;
  padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/features/residents/pages/ResidentByProjectListPage.vue